import { useTheme } from "../styles/theme";

export default function Field({ label, children }) {
  const S = useTheme();
  return (
    <div style={S.formField}>
      <label style={S.label}>{label}</label>
      {children}
    </div>
  );
}
